@if (cService.stepperList) {
  <div class="flex-row">
    <div class="card fluid">
      <div class="card__content stepper">
        <eas-graphic-stepper [stepper]="cService.stepperList" (click)="stepperClick($event)">
        </eas-graphic-stepper>
      </div>
    </div>
  </div>
}
